import { useState, useCallback, useEffect, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ADMIN_DASHBOARD_HEADER } from "../../../../../../../../../constants/caption/dashboardHeader";
import { AuthContext, GroupContext, UIContext } from "../../../../../../../../../contexts";
import { Button, Paper, Grid } from "@material-ui/core";

import DescriptionIcon from "@material-ui/icons/Description";
import VisibilityIcon from "@material-ui/icons/Visibility";
import SystemUpdateAltIcon from "@material-ui/icons/SystemUpdateAlt";
import CreateIcon from "@material-ui/icons/Create";
import WcIcon from "@material-ui/icons/Wc";
import { dependentTypes } from "../../../../../../../../../@types/components/dependent.types";
import ExtractRouteParams from "../../../../../../../../../utils/commonFunctions/extractRouteParams";
import DynamicInformationForm from "../../../../../../../../shared/dynamicInformationForm/DynamicInformationForm";
import useRouteParam from "../../../../../../../../../hooks/useRouteParam";
import ChangeLogInformationForm from "../../../../../../../../shared/changeLogInformationForm/ChangeLogInformationForm";
import ROLES from "../../../../../../../../../constants/roles";
import { trackPromise } from "react-promise-tracker";
import { api } from "../../../../../../../../../utils/api";
import { MemberTypes } from "../../../../../../../../../@types/components/member.types";
import initCapitalize from "../../../../../../../../../utils/commonFunctions/initCapitalize";
import encryption from "../../../../../../../../../utils/commonFunctions/encryption";
import { Member } from "../../../../../../../../../@types/member.types";
import ChangeLogInformation from "../../../../../../../../shared/changeLog/ChangeLog";
import MemberStatusInformation from "../../../../../../../../shared/memberStatusInformation/MemberStatusInformation";
import { DEPENDENT_STATUS } from "../../../../../../../../../constants/dependentStatus";
import DependentStatusInformation from "../../../../../../../../shared/dependentStatusInformation/DependentStatusInformation";
import prefixCharacterAddition from "../../../../../../../../../utils/commonFunctions/prefixCharacterAddition";
import {
	dateTimeZoneConverter,
	mongoDBDateParserToUSAFormat
} from "../../../../../../../../../utils/commonFunctions/date";
import { handleSSNFormat, handleSSNFormatForView } from "../../../../../../../../../utils/commonFunctions/SSN";

const DependentInformationDetails = ({ employee, dependent }: { employee: Member; dependent: Member }): JSX.Element => {
	const [employeeInformation, setEmployeeInformation] = useState([]);
	const [dependentProfileInformation, setdependentProfileInformation] = useState([]);
	const [dependentContactInformation, setDependentContactInformation] = useState([]);
	const { setDashboardHeader } = useContext(UIContext);
	const querySSN = useRouteParam("qs");
	const queryGroupNumber = useRouteParam("gn");
	const routeParam = ExtractRouteParams(); // This is to extract the route after ?(Question Mark)
	const navigate = useNavigate();
	const [isDependentStatus, setIsDependentStatus] = useState<boolean>(false);
	const { user } = useContext(AuthContext);

	const handleEditDependentProfileClick = useCallback(() => {
		const pathname = `/employer/member/dependent/edit-profile?${routeParam}`;
		navigate(pathname);
	}, [navigate]);

	const handleEditDependentContactClick = useCallback(() => {
		const pathname = `/employer/member/dependent/edit-contact?${routeParam}`;
		navigate(pathname);
	}, [navigate]);

	// console.log("Informationcheckforconsole", dependent);

	useEffect(() => {
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.dependent_details);
	}, [setDashboardHeader]);

	useEffect(() => {
		setEmployeeInformation(
			Object.assign(
				[],
				[
					{
						label: "Employee ID",
						name: "member_id",
						value: employee.member_id,
						type: "textfield"
					},
					{
						label: "WLT Employee Number",
						name: "employee_number",
						value: employee.employee_number,
						type: "textfield"
					},
					{
						label: "First Name",
						name: "first_name",
						value: employee.first_name,
						type: "textfield"
					},
					{
						label: "Last Name",
						name: "last_name",
						value: employee.last_name,
						type: "textfield"
					},
					{
						label: "Tobacco",
						name: "is_tobbaco",
						value: employee.is_tobacco == true ? "Yes" : "No",
						type: "textfield"
					},
					{
						// label: "ALT-ID",
						label: "SSN",
						name: "SSN",
						value: handleSSNFormatForView(user, employee.SSN),
						type: "textfield"
					},
					{
						label: "SSN",
						name: "actual_SSN",
						value: handleSSNFormatForView(user, employee.actual_SSN || ""),
						type: "textfield"
					}
				]
			)
		);
	}, [employee]);

	useEffect(() => {
		setdependentProfileInformation(
			Object.assign(
				[],
				[
					{
						label: "WLT Dependent Number",
						name: "dependent_number",
						value: dependent?.dependent_number,
						type: "textfield"
					},
					{
						label: "First Name",
						name: "first_name",
						value: dependent?.first_name,
						type: "textfield"
					},
					{
						label: "Middle Name",
						name: "middle_name",
						value: dependent?.middle_name,
						type: "textfield"
					},
					{
						label: "Last Name",
						name: "last_name",
						value: dependent?.last_name,
						type: "textfield"
					},
					{
						label: "SSN",
						name: "SSN",
						value: handleSSNFormatForView(user, dependent?.SSN),
						type: "textfield"
					},
					{
						label: "Date of Birth",
						name: "date_of_birth",
						value: dateTimeZoneConverter(dependent?.date_of_birth as string),
						type: "textfield"
					},
					{
						label: "Gender",
						name: "gender",
						value:
							dependent?.gender !== null ? initCapitalize(dependent?.gender as string) : dependent.gender,
						type: "textfield"
					},
					{
						label: "Relationship",
						name: "relationship",
						value:
							dependent?.relationship !== null
								? initCapitalize(dependent?.relationship as string)
								: dependent?.relationship,
						type: "textfield"
					},
					{
						label: "Dependent Type",
						name: "dependent_type",
						value: dependent?.dependent_type,
						type: "textfield"
					},
					{
						label: "Registered Dependent",
						name: "is_registered",
						value: dependent?.is_registered === true ? "Yes" : "No",
						type: "textfield"
					},
					{
						label: "Disabled",
						name: "is_disabled",
						value: dependent?.is_disabled == true ? "Yes" : "No",
						type: "textfield"
					},
					{
						label: "Tobacco",
						name: "is_tobbaco",
						value: dependent?.is_tobacco == true ? "Yes" : "No",
						type: "textfield"
					},
					{
						label: "Dependent Profile Access",
						name: "dependent_profile_access",
						value: dependent?.dependent_profile_access == true ? "Yes" : "No",
						type: "textfield"
					},

					{
						label: "Upload Type",
						name: "upload_type",
						value:
							dependent?.upload_type !== null
								? initCapitalize(dependent?.upload_type as string)
								: dependent?.upload_type,

						type: "textfield"
					},
					{
						label: "Dependent Status",
						name: "dependent_status",
						value: employee.is_term
							? "Employee Terminated"
							: dependent.is_term
							? "Removed"
							: dependent?.dependent_status === DEPENDENT_STATUS.active
							? "Active"
							: dependent?.dependent_status === DEPENDENT_STATUS.inactive
							? "Not Yet Registered"
							: null,
						type: "textfield"
					},
					{
						label: "Last Login Date",
						name: "last_login_date",
						value:
							dependent?.last_login_date !== null
								? mongoDBDateParserToUSAFormat(dependent?.last_login_date as unknown as string)
								: "N/A",
						type: "textfield"
					},
					{
						label: "Event Document",
						name: "event_document",
						value: dependent?.event_document,
						type: "icon_button"
					},
					{
						label: "Event Name",
						name: "event_name",
						value: dependent?.event_name,
						type: "textfield"
					},
					{
						label: "Event Date",
						name: "event_date",
						value: dateTimeZoneConverter(dependent?.event_date),
						type: "textfield"
					}
				]
			)
		);
	}, [dependent]);

	useEffect(() => {
		setDependentContactInformation(
			Object.assign(
				[],
				[
					{
						label: "Contact Label",
						name: "contact_label",
						value:
							dependent?.contact_label !== null
								? initCapitalize(dependent.contact_label as string)
								: dependent?.contact_label,
						type: "textfield"
					},
					{
						label: "Email",
						name: "email",
						value: dependent.email,
						type: "textfield"
					},
					{
						label: "Phone Number",
						name: "phone_number",
						value: dependent.phone_number,
						type: "textfield"
					},
					{
						label: "Phone Extension",
						name: "phone_extension",
						value: dependent.phone_extension,
						type: "textfield"
					},
					{
						label: "Address Line 1",
						name: "address_line_1",
						value: dependent.address_line_1,
						type: "textfield"
					},
					{
						label: "Address Line 2",
						name: "address_line_2",
						value: dependent.address_line_2,
						type: "textfield"
					},
					{
						label: "City",
						name: "city",
						value: dependent.city,
						type: "textfield"
					},
					{
						label: "State",
						name: "state",
						value: dependent.state,
						type: "textfield"
					},
					{
						label: "Country",
						name: "country",
						value: dependent.country,
						type: "textfield"
					},
					{
						label: "ZIP Code",
						name: "ZIP",
						value:
							String(dependent.ZIP).length > 5
								? dependent?.ZIP?.substring(0, 5) + "-" + dependent?.ZIP?.substring(5)
								: dependent?.ZIP,
						type: "textfield"
					}
				]
			)
		);
	}, [dependent]);

	useEffect(() => {
		if (dependent) {
			const { dependent_status } = dependent;

			if (dependent_status === DEPENDENT_STATUS.removed) setIsDependentStatus(true);
			else setIsDependentStatus(false);
		}
	}, []);

	// console.log("depedent details -> ", dependent);

	return (
		<div className="dependent-information-details-container" id="dependent-information-details-container">
			<div className="pf-title">Employee Information</div>
			<div className="change-log-container">
				{employee !== undefined ? <MemberStatusInformation memberInstance={employee} /> : null}
			</div>
			<div className="dynamic-form-container" id="dynamic-form-container">
				{employeeInformation !== undefined ? (
					<DynamicInformationForm
						informationFormData={employeeInformation}
						employee_id={employee._id}
						employee_role={employee.role}
					/>
				) : null}
			</div>

			<div className="pf-title">Dependent Profile Information</div>
			<div className="pf-action-button-container" id="pf-action-button-container">
				{!isDependentStatus ? (
					<Button className="button-black" onClick={handleEditDependentProfileClick} variant="contained">
						<span className="button-label-with-icon">Edit</span>
						<span>
							<CreateIcon className="button-icon" />
						</span>
					</Button>
				) : null}
			</div>
			<div className="change-log-container">
				{employee?.is_term ? (
					<DependentStatusInformation
						memberInstance={employee}
						employee_id={employee._id}
						employee_role={employee.role}
					/>
				) : (
					<DependentStatusInformation
						memberInstance={dependent}
						employee_id={employee._id}
						employee_role={employee.role}
					/>
				)}
			</div>
			<div className="dynamic-form-container" id="dynamic-form-container">
				{dependentProfileInformation !== undefined ? (
					<DynamicInformationForm
						informationFormData={dependentProfileInformation}
						employee_id={employee._id}
						employee_role={employee.role}
					/>
				) : null}
			</div>
			<div className="pf-title">Dependent Contact Information</div>
			<div className="pf-action-button-container" id="pf-action-button-container">
				{!isDependentStatus ? (
					<Button className="button-black" variant="contained" onClick={handleEditDependentContactClick}>
						<span className="button-label-with-icon">Edit</span>
						<span>
							<CreateIcon className="button-icon" />
						</span>
					</Button>
				) : null}
			</div>
			<div className="dynamic-form-container" id="dynamic-form-container">
				{dependentContactInformation !== undefined ? (
					<DynamicInformationForm
						informationFormData={dependentContactInformation}
						employee_id={employee._id}
						employee_role={employee.role}
					/>
				) : null}
			</div>
			<div className="change-log-container">
				{dependent !== undefined ? <ChangeLogInformation changeLogInstance={dependent} /> : null}
			</div>
		</div>
	);
};

export default DependentInformationDetails;
